/* One tooltip for all native and predictive cards, including AJAX-rendered results. */
(() => {
  if (window.FHCardTooltips) return;
  const selector = '[data-fh-tooltip]';
  let tip, anchor, described, previousDescription, mode, closeTimer, positionFrame;
  function placement(rect, width, height, viewportWidth, viewportHeight) {
    const left = Math.max(8, Math.min(rect.left + rect.width / 2 - width / 2, viewportWidth - width - 8));
    const above = rect.top - height - 10;
    const top = above >= 8 ? above : Math.min(rect.bottom + 10, viewportHeight - height - 8);
    return {left, top: Math.max(8, Math.min(top, viewportHeight - height - 8)), side: above >= 8 ? 'above' : 'below', arrow: Math.max(12, Math.min(rect.left + rect.width / 2 - left, width - 12))};
  }
  function hide() {
    clearTimeout(closeTimer);
    if (positionFrame !== undefined) cancelAnimationFrame(positionFrame);
    positionFrame = undefined;
    if (!anchor) return;
    if (previousDescription === null) described?.removeAttribute('aria-describedby');
    else described?.setAttribute('aria-describedby', previousDescription);
    if (typeof tip.hidePopover === 'function' && tip.matches(':popover-open')) tip.hidePopover();
    tip.hidden = true;
    anchor = described = null;
    mode = undefined;
  }
  function scheduleHide() { clearTimeout(closeTimer); closeTimer = setTimeout(hide, 140); }
  function show(target, label, source, descriptionTarget = target) {
    if (!label) return;
    clearTimeout(closeTimer);
    if (anchor === target && mode === source) return;
    hide();
    if (!tip) {
      tip = document.createElement('div');
      tip.id = 'fh-card-tooltip'; tip.className = 'fh-card-tooltip'; tip.setAttribute('role', 'tooltip');
      if (typeof tip.showPopover === 'function') tip.setAttribute('popover', 'manual');
      tip.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      tip.addEventListener('pointerleave', scheduleHide);
    }
    // Popover escapes card clipping and dialog stacking without moving focus.
    (target.closest('dialog[open]') || document.body).append(tip);
    tip.textContent = label; tip.hidden = false;
    if (typeof tip.showPopover === 'function') tip.showPopover();
    anchor = target; described = descriptionTarget; mode = source;
    previousDescription = described.getAttribute('aria-describedby');
    described.setAttribute('aria-describedby', [previousDescription, tip.id].filter(Boolean).join(' '));
    position();
  }
  function position() {
    const box = tip.getBoundingClientRect();
    const p = placement(anchor.getBoundingClientRect(), box.width, box.height, innerWidth, innerHeight);
    tip.style.left = `${p.left}px`; tip.style.top = `${p.top}px`;
    tip.style.setProperty('--fh-tooltip-arrow', `${p.arrow}px`); tip.dataset.side = p.side;
  }
  function scroll(event) {
    if (event.target === tip || !anchor) return;
    if (mode !== 'focus' || document.activeElement !== described) { hide(); return; }
    // Tab may scroll its newly focused card after focusin. Keep its description
    // and coalesce geometry reads without reopening the popover or its animation.
    if (positionFrame !== undefined) return;
    positionFrame = requestAnimationFrame(() => {
      positionFrame = undefined;
      if (mode === 'focus' && anchor?.isConnected && document.activeElement === described) position();
      else hide();
    });
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const target = event.target.closest(selector);
    if (target) show(target, target.dataset.fhTooltip, 'hover');
  });
  document.addEventListener('pointerout', event => {
    if (mode !== 'hover' || !anchor || !anchor.contains(event.target)) return;
    if (anchor.contains(event.relatedTarget) || tip.contains(event.relatedTarget)) return;
    scheduleHide();
  });
  document.addEventListener('focusin', event => {
    const card = event.target.closest('[data-fh-product-card]');
    if (!card?.matches(':focus-visible')) return;
    const group = card.querySelector('.fh-card-identities');
    const labels = [...(group?.querySelectorAll(selector) || [])].map(n => n.dataset.fhTooltip).filter(Boolean);
    if (group && labels.length) show(group, [...new Set(labels)].join(' · '), 'focus', card);
  });
  document.addEventListener('focusout', () => { if (mode === 'focus') hide(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && anchor) { hide(); event.stopPropagation(); event.preventDefault(); }
  }, true);
  document.addEventListener('pointerdown', hide);
  document.addEventListener('scroll', scroll, {capture: true, passive: true});
  window.addEventListener('resize', hide);
  window.addEventListener('blur', hide);
  window.FHCardTooltips = {placement, hide};
})();
